import { _ } from "../../../../../core/polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import WysiwygViewerWidget from "../../../../../core/widgets/WysiwygViewerWidget/WysiwygViewerWidget.js";

/**
 * Shows the rule model description delegating on the
 * state of the RuleTemplatesWidget.
 *
 * The rule model description is shown using a Wysiwyg Viewer.
 *
 * @param {AbstractRuleTemplateModel} ruleTemplateModel - Widget's model
 *   holding the type of ruleTemplate that is rendered here
 * @param {AbstractRuleTemplateState} state - State of the RuleTemplatesWidget
 */
export default class RuleTemplateDescriptionWidget extends Widget {
	constructor({ ruleTemplateModel, state } = {}) {
		super(...arguments);

		this._ruleTemplateModel = ruleTemplateModel;
		this._currentState = state;
	}

	renderContentOn(html) {
		if (!this._ruleTemplateModel.hasDescription()) return;

		html.div(
			{ class: "rule-template-info", "data-test": "description" },
			this._ruleTemplateModel.ruleTemplateDescriptionWidgetRenderer(this),
		);
	}

	setState(state) {
		this._currentState = state;
		this.update();
	}

	setRuleTemplateModel(ruleTemplateModel) {
		this._ruleTemplateModel = ruleTemplateModel;
		this.update();
	}

	renderRuleTemplateDescriptionOn(html) {
		html.div(
			{ class: "rule-model-header" },
			html.h4({ class: "rule-model-name" }, _("Description")),
			this._currentState.ruleTemplateDescriptionRenderer(this),
		);
	}

	makeDescriptionViewer() {
		return new WysiwygViewerWidget({
			content: this._ruleTemplateModel.getDescription(),
		});
	}
}
